import {Vue} from 'vue-property-decorator';
import GmapVue from 'gmap-vue';

Vue.use(GmapVue, {
	// If you intend to programmatically custom event listener code
	// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
	// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
	// you might need to turn this on.
	// autoBindAllEvents: false,

	// If you want to manually install components, e.g.
	// import {GmapMarker} from 'gmap-vue/src/components/marker'
	// Vue.component('GmapMarker', GmapMarker)
	// then set installComponents to 'false'.
	// If you want to automatically install all the components this property must be set to 'true':
	installComponents: true,
	dynamicLoad: true
});

declare module 'vue/types/vue' {
	interface Vue {
		$gmapApiPromiseLazy: () => Promise<void>;
	}
}
